import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class Transaction {
  constructor (params = {}) {
    const {
      id,
      sequence,
      externalIds,
      amount,
      paymentMethod,
      paymentMethodId,
      account,
      accountId,
      guest,
      guestId,
      currency,
      currencyId,
      type,
      created,
      concept,
      reference,
      notified,
      attributes,
      station,
      stationId,
      operator,
      operatorId,
      relatedTransactionId,
      exchangeCurrency,
      exchangeCurrencyId,
      exchangeValue,
      orderId,
      orderRefundId,
      relatedTransactions,
      relatedTransactionIds
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.amount = typeof amount === 'number' ? amount : null
    this.paymentMethodId = paymentMethodId || null
    this.paymentMethod = paymentMethod || this.paymentMethodId
    this.accountId = accountId || null
    this.account = account || this.accountId
    this.guestId = guestId || null
    this.guest = guest || this.guestId
    this.currencyId = currencyId || null
    this.currency = currency || this.currencyId
    this.type = type || null
    this.created = created || null
    this.concept = concept || null
    this.reference = reference || null
    this.notified = notified || null
    this.attributes = attributes || null
    this.stationId = stationId || null
    this.station = station || this.stationId
    this.operatorId = operatorId || null
    this.operator = operator || this.operatorId
    this.relatedTransactionId = relatedTransactionId || null
    this.exchangeCurrencyId = exchangeCurrencyId || null
    this.exchangeCurrency = exchangeCurrency || this.exchangeCurrencyId
    this.exchangeValue = exchangeValue || null
    this.orderId = orderId || null
    this.orderRefundId = orderRefundId || null
    this.relatedTransactions = relatedTransactions || []
    this.relatedTransactionIds = relatedTransactionIds || []
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      external_id: item.externalId,
      relatedTransactionId: item.relatedTransactionId,
      paymentMethodId: item.paymentMethodId,
      exchangeCurrencyId: item.exchangeCurrencyId,
      exchangeValue: item.exchangeValue,
      amount: item.amount,
      type: item.type,
      accountId: item.accountId,
      guestId: item.guestId,
      concept: item.concept,
      moment: new Date(),
      currencyId: item.currencyId,
      stationId: item.stationId,
      operatorId: item.operatorId
    }
  }
}
